<template>
  <div class="row flex-column flex-md-row">
    <div class="col-12 col-sm-6 justify-content-center d-flex flex-column">
      <img :alt="project.nombre"
           class="img-fluid "
           :src="project.foto">
    </div>
    <div class="col-12 col-sm-5 offset-sm-1 justify-content-center d-flex flex-column">
      <p class="text accent blueText mb-0">{{ project.nombre }}</p>
      <p class="text text-orange big mb-0">{{ project.subtitulo }}</p>
      <p class="text text-orange curve small mb-0">{{ project.lugar }}</p>

      <p class="text text-orange big my-1 my-md-5"
         v-html="project.descripcion[this.$i18n.locale()]"/>

      <p class="text blueText accent mb-0 font-weight-bold">{{ 'works.portfolio.modal.tecnology' | translate }}</p>
      <p class="text text-orange big">{{ project.tecnologias }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PortfolioSoftwareProject',
    props: {
      project: {
        type: Object,
        default () {
          return {
            foto: null,
            nombre: '',
            subtitulo: '',
            lugar: '',
            descripcion: {
              es: '',
              en: ''
            },
            tecnologias: ''
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles/colors";

  .text {
    font-family: "Open Sans", sans-serif;

    &.accent {
      font-weight: 800;
      font-size: 1.9rem;

      @media (min-width: 767px) {
        font-size: 2.2rem
      }

    }

    &.small {
      font-size: 1.5rem;
    }

    &.big {
      font-size: 1.2rem;

      @media (min-width: 1400px) {
        font-size: 2.2rem
      }
    }

    &.curve {
      font-style: italic;
    }
  }

  .url {
    font-size: 1.5rem;
    font-family: "Open Sans", sans-serif;
    text-shadow: 1px 2px #ffffff78;
    color: $blue-accent;
    cursor: pointer;
  }

  .blueText {
    color: #00839E;
  }

  .text-orange {
    color: $light-orange;
  }

  .text-country-date {
    font-size: 1.9rem;
  }

  .text-name {
    font-size: 2.2rem;
    font-weight: 800;
  }

  .monitor-placeholder {
    background: #111010;
    flex-grow: 1;
    border-radius: 25px;
    width: 88%;
    position: relative;
    padding: 2%
  }
</style>



// WEBPACK FOOTER //
// src/components/PortfolioSoftwareProject.vue